export const PROFILE_DATA = 'ProfileData';
export const USER_PROFILE = 'UserProfile';
//# sourceMappingURL=profile.js.map